import FlipbookViewer from "../components/FlipbookViewer";

export default function PoolHeaters() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">HEATERS</h1>
        </div>
      </section>

      

          {/* Brochure Section */}
          <section className="py-12 md:py-16 bg-gray-50">
              <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
                  <p className="text-sm md:text-base text-gray-700 mb-8">Check out the new Brochure below!</p>
              </div>
              <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                  <FlipbookViewer
                      title="Pool Heaters Catalog"
                      downloadUrl="/images/HeaterCatalog.pdf"
          />
        </div>
      </section>
    </div>
  );
}